import { useState } from 'react'
import { apiSetup, ui } from './shared'

export function SetupPage({ onSetupDone }: { onSetupDone: () => void }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    if (username.length < 3) return setError('Username ≥ 3 caratteri.')
    if (password.length < 10) return setError('Password ≥ 10 caratteri.')
    if (password !== confirm) return setError('Le password non coincidono.')
    setBusy(true)
    try {
      await apiSetup(username, password)
      onSetupDone()
    } catch (err) {
      setError(String(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--paper)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <form onSubmit={submit} style={{ ...ui.card, width: '100%', maxWidth: 420 }}>
        <h1 style={ui.sectionTitle}>Imposta l'utente admin</h1>
        <p style={{ fontSize: 13, color: 'var(--fg-muted)', marginTop: -6, marginBottom: 18 }}>
          Primo accesso: scegli username e password. Questi verranno salvati nel database (password hashata con bcrypt).
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <label>
            <span style={ui.label}>Username</span>
            <input style={ui.input} autoFocus value={username} onChange={(e) => setUsername(e.target.value)} />
          </label>
          <label>
            <span style={ui.label}>Password (≥ 10 caratteri)</span>
            <input style={ui.input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          <label>
            <span style={ui.label}>Conferma password</span>
            <input style={ui.input} type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </label>
          {error && <div style={{ color: '#a33', fontSize: 13 }}>{error}</div>}
          <button type="submit" style={{ ...ui.btn, marginTop: 8, opacity: busy ? 0.5 : 1 }} disabled={busy}>
            {busy ? '…' : 'Crea admin'}
          </button>
        </div>
      </form>
    </div>
  )
}
